import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Slider,
  Typography,
  useTheme,
} from "@mui/material";
import { useStyles } from "../../style";
import TimeSeries from "shared-component/timeseries";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import HistogramIcon from "assets/histogramIcon";
import { fomrattedTimeWithT, generateTimeSeriesData, getTimeList, getVinListMapData } from "utility/helper";
import TimeSeriesMutliFilterComponent from "./TimeSeriesMultiFilterComponent";
import { timeSeriesdata } from "assets/DataFile/headerPageData";

dayjs.extend(utc);

interface TimeSeriesVisualizationPropTypes {
  vinListTimeSeries: string[];
  updateTimeSeriesFilter: (value: any) => void;
  singnalListData: string[];
  userInputData: string[];
  jobDetails: any;
  headerJobId: string;
  setSelectedVinListVisualization: (value: any) => void;
  selectedVINs: string[];
  requestTimeListTimeSeries?: string[];
}

const TimeSeriesVisualization = (props: TimeSeriesVisualizationPropTypes) => {
  const style = useStyles();
  console.log('pr', props)
  const [timeSeriesData, setTimeSeriesData] = React.useState<any>([]);
  const [, setVinList] = React.useState<any>([]);
  const [signal, setSignal] = React.useState<any>([]);
  const [filterStartDate, setFilterStartDate] = React.useState<any>(null);
  const [filterEndDate, setFilterEndDate] = React.useState<any>(null);
  const [value, setValue] = React.useState<number[]>([0, 24]);
  const [range, setRange] = useState<string[]>(['', ''])
  const [vinListData, setVinListData] = useState<string[]>(props?.vinListTimeSeries);
  const [timeSeriesTimeList, setTimeSeriesTimeList] = useState<any>(null);
  const dataa: any = {}
  const { cDadDataVisualizationData, linkCdadFilterAttributes } = dataa
  const theme = useTheme();
  const handleChange = (event: Event, newValue: number | number[]) => {
    setValue(newValue as number[]);
  };

  function unpack(rows: any, key: any) {
    return rows?.map(function (row: any) { return row[key]; });
  }

  const setTargetVin = (value: any) => {
    setVinList(value.vinList)
    setSignal(value.signalList)
    setFilterStartDate(value.filterStartDate)
    setFilterEndDate(value.filterEndDate)
    props.updateTimeSeriesFilter(value);
  }
  useEffect(() => {
    const apiData = timeSeriesdata;
    const updatedData = generateTimeSeriesData(apiData)
    let list: any = [];
    signal?.length > 0 && signal?.forEach((element: string) => {
      const listItem: any = []
      const dataTimeSeries = updatedData?.length > 0 ? updatedData[0] : updatedData;
      dataTimeSeries && Object.entries(dataTimeSeries)?.forEach((item: any) => {
        listItem.push(generateLineData(element, item))
      })
      list.push(listItem);
    })
    setTimeSeriesData(list);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (filterStartDate && filterEndDate && filterStartDate !== '' && filterEndDate !== '') {
      setRange([fomrattedTimeWithT(filterStartDate), fomrattedTimeWithT(filterEndDate)]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterEndDate, filterStartDate])

  useEffect(() => {
    console.log('linkCdadFilterAttributes', linkCdadFilterAttributes)
    if(linkCdadFilterAttributes) {
      setVinListData(getVinListMapData(linkCdadFilterAttributes))
      setTimeSeriesTimeList(getTimeList(linkCdadFilterAttributes?.available_attributes))
    }
   
  }, [linkCdadFilterAttributes])

  const generateLineData = (signalName: string, dataList: any) => {
    const lineData = {
      x: unpack(dataList[1], 'gpsDateTime'),
      y: unpack(dataList[1], signalName),
      line: '#E70B0B',
      name: dataList[0]?.length > 4 ? dataList[0]?.substr(-4) : null
    }
    return lineData;
  }

  const marksd = [
    { value: 0, label: '12:00 AM' },
    { value: 6, label: '6:00 AM' },
    { value: 12, label: '12:00 PM' },
    { value: 18, label: '6:00 PM' },
    { value: 24, label: '12:00 AM' }
  ];

  const timeSeriesWidth = window.innerWidth > 1350 ? 800 : timeSeriesData?.length === 1 ? 850 : 425;
  const timeSeriesHeight = window.innerWidth > 1350 ? 500 : timeSeriesData?.length === 1 ? 550 : 400;
  return (
    <Box>
      {(cDadDataVisualizationData?.isLoading || linkCdadFilterAttributes?.isLoading) &&
        <div className={style.overlay}>
          <div className={style.loader}></div>
        </div>}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div>
          <TimeSeriesMutliFilterComponent signalList={props?.userInputData} vinListTimeSeries={vinListData} setSelectedVinList={setTargetVin} setSelectedVinListVisualization={props.setSelectedVinListVisualization} selectedVINs={props.selectedVINs} requestTimeListTimeSeries={props?.requestTimeListTimeSeries} timeSeriesTimeList={timeSeriesTimeList} />
        </div>
        <div
          style={{
            display: 'flex',
          }}
        >
          <Paper
            elevation={2}
            sx={{
              marginTop: "1%",
              width: '100%',
            }}
          >
            <div style={{ textAlign: "center" }}>
              {(timeSeriesData === null || timeSeriesData?.length === 0) && <Box
                flex={1}
                my={2}
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
              >
                <HistogramIcon />
                <Typography
                  variant="caption"
                  textAlign={"center"}
                  color={theme.palette.text.disabled}
                  fontWeight={"bold"}
                  width={350}
                >
                  Use the filters from dropdowns to analyse in time series filters!
                </Typography>
              </Box>}
              {timeSeriesData?.length > 0 && <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                rowGap: '1rem',
                columnGap: '1rem',
                padding: '1rem'
              }}>
                {timeSeriesData?.length > 0 ?
                  timeSeriesData?.map((item: any, index: number) => {
                    return (
                      <Paper
                        elevation={2}
                        sx={{
                          width: '100%',
                        }}
                      >
                        <TimeSeries data={item} range={range} width={timeSeriesWidth} height={timeSeriesHeight} title={signal[index]} />
                      </Paper>
                    )
                  }) : null
                }
              </div>}
              {timeSeriesData?.length > 0 && <Slider
                style={{ width: '50%' }}
                min={0}
                max={24}
                marks={marksd}
                getAriaLabel={() => 'Temperature range'}
                value={value}
                onChange={handleChange}
                valueLabelDisplay="auto"
              />}
            </div>
          </Paper>
        </div>
      </div>
    </Box >
  );
};

export default TimeSeriesVisualization;  